// extracted by mini-css-extract-plugin
export default {"btn":"AddToDealsBtn_btn__YT3IW"};